import PatientList from "../partnerPortal/booking";

const ManageDuty = () => {
  return (
    <div>
      <PatientList />
    </div>
  );
};

export default ManageDuty;
